import { Grid, Typography } from "@mui/material";
import { TextField } from "src/components/FormikComponents/TextField";
import { useSelector } from "react-redux";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import { IPairingBuilderDefinitionPositions } from "@vmosolutions/oc-interfaces";
// Position Imports
import { PositionBadge } from "src/components/CrewSchedule/PositionBadge";
import { useMemo } from "react";
import { isEqual } from "lodash";

interface IDefinitionPositionsProps {
  initialValue: IPairingBuilderDefinitionPositions[];
  value: IPairingBuilderDefinitionPositions[];
  onChange: (value: IPairingBuilderDefinitionPositions[]) => void;
  disabled?: boolean;
}

const returnNewPositions = (
  value: IPairingBuilderDefinitionPositions[],
  title: string,
  newCount: number | string
): IPairingBuilderDefinitionPositions[] => {
  const updatedPositions = [...value];
  const index = value.findIndex((pos) => pos.position === title);
  const numberCount = typeof newCount === "string" ? parseInt(newCount) : newCount;
  //if the pos doesn't exist on the def already, index is going to be -1. so in that case, set the index to value.length
  const posIndex = index >= 0 ? index : (value?.length ?? 0);
  updatedPositions[posIndex] = { position: title, count: numberCount };
  return updatedPositions;
};

export const DefinitionPositions = (props: IDefinitionPositionsProps): JSX.Element => {
  const { initialValue, value, onChange, disabled } = props;

  const positionDirty = !isEqual(initialValue, value);

  // Position types
  const positionsTypes = useSelector((state: IRootState) => state.structures.customerStructure.positions);
  const positionTitles = useMemo(
    () => positionsTypes?.sort((a, b) => a.displayOrder - b.displayOrder)?.map((pos) => pos.title),
    [positionsTypes]
  );

  return (
    <Grid container wrap="nowrap" alignItems="center" className={`positions_control ${positionDirty ? "dirty" : ""}`}>
      <Typography variant="caption" className="definition_name" style={{ minWidth: 80 }}>
        Positions
      </Typography>

      {positionTitles?.map((title, index) => {
        const initialCount = initialValue.filter((item: any) => item.position === title)?.[0]?.count ?? 0;
        const count = value.filter((item: any) => item.position === title)?.[0]?.count ?? 0;
        const isDirty = initialCount !== count;

        return (
          <Grid container key={`position_control_${title}_${index}`} style={{ width: "auto" }} alignItems="center">
            <Grid item style={{ height: 16 }}>
              <PositionBadge positionTitle={title} filled={count > 0} />
            </Grid>
            <TextField
              className={`position_slot no_arrows ${isDirty ? "dirty" : ""}`}
              label=""
              value={count}
              onChange={(event: any) => {
                const newPositions = returnNewPositions(value, title, event?.target?.value);
                onChange(newPositions);
              }}
              type="number"
              disabled={disabled}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
